import { useFrequencyNewsletterGql } from './useFrequencyNewsletterGql';
import { usePauseNewsletterGql } from './usePauseNewsletterGql';
import { useUnsubscribeNewsletterGql } from './useUnsubscribeNewsletterGql';

export const useExecuteUnsubscribe = () => {
  const unsubscribeNewsletterGql = useUnsubscribeNewsletterGql();
  const frequencyNewsletterGql = useFrequencyNewsletterGql();
  const pauseNewsletterGql = usePauseNewsletterGql();
  const executeUnsubscribe = ({
    email,
    frequency,
    pause,
  }: {
    email: string;
    frequency: string;
    pause?: string;
  }) => {
    const [type, value] = frequency.split('|');
    switch (type) {
      case 'unsubscribe':
        return unsubscribeNewsletterGql({ emailAddress: email });
      case 'frequency':
        return frequencyNewsletterGql({
          emailAddress: email,
          frequency: value,
        });
      case 'pause':
        return pauseNewsletterGql({ emailAddress: email, pauseDays: Number(pause) });
      default:
        return Promise.reject(new Error('Invalid frequency type'));
    }
  };
  return executeUnsubscribe;
};
